// Catálogo de países para los teléfonos: código ISO-3166 alpha-2, nombre en
// español e indicativo E.164.
//
// GENERADO, no escrito a mano: los indicativos y el país principal de cada
// indicativo salen de los metadatos de libphonenumber-js y los nombres de
// Intl.DisplayNames("es"). Se dejó como datos estáticos a propósito —
// libphonenumber-js está en node_modules sólo como dependencia transitiva, y
// depender de ella en tiempo de ejecución la volvería una dependencia real sin
// declararla. Para regenerarlo, ver el comentario al final del archivo.
//
// `primary` marca el país principal de un indicativo compartido: +1 son 25
// países, así que al leer un número guardado hay que decidir cuál mostrar.
// Sin esta marca, un +1 estadounidense podría reaparecer como Anguila.

export const DEFAULT_PHONE_COUNTRY = "CO";

export const PHONE_COUNTRIES = [
  { code: "AF", name: "Afganistán", dial: "+93", primary: true },
  { code: "AL", name: "Albania", dial: "+355", primary: true },
  { code: "DE", name: "Alemania", dial: "+49", primary: true },
  { code: "AD", name: "Andorra", dial: "+376", primary: true },
  { code: "AO", name: "Angola", dial: "+244", primary: true },
  { code: "AI", name: "Anguila", dial: "+1" },
  { code: "AG", name: "Antigua y Barbuda", dial: "+1" },
  { code: "SA", name: "Arabia Saudí", dial: "+966", primary: true },
  { code: "DZ", name: "Argelia", dial: "+213", primary: true },
  { code: "AR", name: "Argentina", dial: "+54", primary: true },
  { code: "AM", name: "Armenia", dial: "+374", primary: true },
  { code: "AW", name: "Aruba", dial: "+297", primary: true },
  { code: "AU", name: "Australia", dial: "+61", primary: true },
  { code: "AT", name: "Austria", dial: "+43", primary: true },
  { code: "AZ", name: "Azerbaiyán", dial: "+994", primary: true },
  { code: "BS", name: "Bahamas", dial: "+1" },
  { code: "BD", name: "Bangladés", dial: "+880", primary: true },
  { code: "BB", name: "Barbados", dial: "+1" },
  { code: "BH", name: "Baréin", dial: "+973", primary: true },
  { code: "BE", name: "Bélgica", dial: "+32", primary: true },
  { code: "BZ", name: "Belice", dial: "+501", primary: true },
  { code: "BJ", name: "Benín", dial: "+229", primary: true },
  { code: "BM", name: "Bermudas", dial: "+1" },
  { code: "BY", name: "Bielorrusia", dial: "+375", primary: true },
  { code: "BO", name: "Bolivia", dial: "+591", primary: true },
  { code: "BA", name: "Bosnia y Herzegovina", dial: "+387", primary: true },
  { code: "BW", name: "Botsuana", dial: "+267", primary: true },
  { code: "BR", name: "Brasil", dial: "+55", primary: true },
  { code: "BN", name: "Brunéi", dial: "+673", primary: true },
  { code: "BG", name: "Bulgaria", dial: "+359", primary: true },
  { code: "BF", name: "Burkina Faso", dial: "+226", primary: true },
  { code: "BI", name: "Burundi", dial: "+257", primary: true },
  { code: "BT", name: "Bután", dial: "+975", primary: true },
  { code: "CV", name: "Cabo Verde", dial: "+238", primary: true },
  { code: "KH", name: "Camboya", dial: "+855", primary: true },
  { code: "CM", name: "Camerún", dial: "+237", primary: true },
  { code: "CA", name: "Canadá", dial: "+1" },
  { code: "BQ", name: "Caribe neerlandés", dial: "+599" },
  { code: "QA", name: "Catar", dial: "+974", primary: true },
  { code: "TD", name: "Chad", dial: "+235", primary: true },
  { code: "CZ", name: "Chequia", dial: "+420", primary: true },
  { code: "CL", name: "Chile", dial: "+56", primary: true },
  { code: "CN", name: "China", dial: "+86", primary: true },
  { code: "CY", name: "Chipre", dial: "+357", primary: true },
  { code: "VA", name: "Ciudad del Vaticano", dial: "+39" },
  { code: "CO", name: "Colombia", dial: "+57", primary: true },
  { code: "KM", name: "Comoras", dial: "+269", primary: true },
  { code: "CG", name: "Congo", dial: "+242", primary: true },
  { code: "KP", name: "Corea del Norte", dial: "+850", primary: true },
  { code: "KR", name: "Corea del Sur", dial: "+82", primary: true },
  { code: "CR", name: "Costa Rica", dial: "+506", primary: true },
  { code: "CI", name: "Côte d’Ivoire", dial: "+225", primary: true },
  { code: "HR", name: "Croacia", dial: "+385", primary: true },
  { code: "CU", name: "Cuba", dial: "+53", primary: true },
  { code: "CW", name: "Curazao", dial: "+599", primary: true },
  { code: "DK", name: "Dinamarca", dial: "+45", primary: true },
  { code: "DM", name: "Dominica", dial: "+1" },
  { code: "EC", name: "Ecuador", dial: "+593", primary: true },
  { code: "EG", name: "Egipto", dial: "+20", primary: true },
  { code: "SV", name: "El Salvador", dial: "+503", primary: true },
  { code: "AE", name: "Emiratos Árabes Unidos", dial: "+971", primary: true },
  { code: "ER", name: "Eritrea", dial: "+291", primary: true },
  { code: "SK", name: "Eslovaquia", dial: "+421", primary: true },
  { code: "SI", name: "Eslovenia", dial: "+386", primary: true },
  { code: "ES", name: "España", dial: "+34", primary: true },
  { code: "US", name: "Estados Unidos", dial: "+1", primary: true },
  { code: "EE", name: "Estonia", dial: "+372", primary: true },
  { code: "SZ", name: "Esuatini", dial: "+268", primary: true },
  { code: "ET", name: "Etiopía", dial: "+251", primary: true },
  { code: "PH", name: "Filipinas", dial: "+63", primary: true },
  { code: "FI", name: "Finlandia", dial: "+358", primary: true },
  { code: "FJ", name: "Fiyi", dial: "+679", primary: true },
  { code: "FR", name: "Francia", dial: "+33", primary: true },
  { code: "GA", name: "Gabón", dial: "+241", primary: true },
  { code: "GM", name: "Gambia", dial: "+220", primary: true },
  { code: "GE", name: "Georgia", dial: "+995", primary: true },
  { code: "GH", name: "Ghana", dial: "+233", primary: true },
  { code: "GI", name: "Gibraltar", dial: "+350", primary: true },
  { code: "GD", name: "Granada", dial: "+1" },
  { code: "GR", name: "Grecia", dial: "+30", primary: true },
  { code: "GL", name: "Groenlandia", dial: "+299", primary: true },
  { code: "GP", name: "Guadalupe", dial: "+590", primary: true },
  { code: "GU", name: "Guam", dial: "+1" },
  { code: "GT", name: "Guatemala", dial: "+502", primary: true },
  { code: "GF", name: "Guayana Francesa", dial: "+594", primary: true },
  { code: "GG", name: "Guernesey", dial: "+44" },
  { code: "GN", name: "Guinea", dial: "+224", primary: true },
  { code: "GQ", name: "Guinea Ecuatorial", dial: "+240", primary: true },
  { code: "GW", name: "Guinea-Bisáu", dial: "+245", primary: true },
  { code: "GY", name: "Guyana", dial: "+592", primary: true },
  { code: "HT", name: "Haití", dial: "+509", primary: true },
  { code: "HN", name: "Honduras", dial: "+504", primary: true },
  { code: "HU", name: "Hungría", dial: "+36", primary: true },
  { code: "IN", name: "India", dial: "+91", primary: true },
  { code: "ID", name: "Indonesia", dial: "+62", primary: true },
  { code: "IQ", name: "Irak", dial: "+964", primary: true },
  { code: "IR", name: "Irán", dial: "+98", primary: true },
  { code: "IE", name: "Irlanda", dial: "+353", primary: true },
  { code: "AC", name: "Isla de la Ascensión", dial: "+247", primary: true },
  { code: "IM", name: "Isla de Man", dial: "+44" },
  { code: "CX", name: "Isla de Navidad", dial: "+61" },
  { code: "NF", name: "Isla Norfolk", dial: "+672", primary: true },
  { code: "IS", name: "Islandia", dial: "+354", primary: true },
  { code: "AX", name: "Islas Aland", dial: "+358" },
  { code: "KY", name: "Islas Caimán", dial: "+1" },
  { code: "CC", name: "Islas Cocos", dial: "+61" },
  { code: "CK", name: "Islas Cook", dial: "+682", primary: true },
  { code: "FO", name: "Islas Feroe", dial: "+298", primary: true },
  { code: "FK", name: "Islas Malvinas", dial: "+500", primary: true },
  { code: "MP", name: "Islas Marianas del Norte", dial: "+1" },
  { code: "MH", name: "Islas Marshall", dial: "+692", primary: true },
  { code: "SB", name: "Islas Salomón", dial: "+677", primary: true },
  { code: "TC", name: "Islas Turcas y Caicos", dial: "+1" },
  { code: "VG", name: "Islas Vírgenes Británicas", dial: "+1" },
  { code: "VI", name: "Islas Vírgenes de EE. UU.", dial: "+1" },
  { code: "IL", name: "Israel", dial: "+972", primary: true },
  { code: "IT", name: "Italia", dial: "+39", primary: true },
  { code: "JM", name: "Jamaica", dial: "+1" },
  { code: "JP", name: "Japón", dial: "+81", primary: true },
  { code: "JE", name: "Jersey", dial: "+44" },
  { code: "JO", name: "Jordania", dial: "+962", primary: true },
  { code: "KZ", name: "Kazajistán", dial: "+7" },
  { code: "KE", name: "Kenia", dial: "+254", primary: true },
  { code: "KG", name: "Kirguistán", dial: "+996", primary: true },
  { code: "KI", name: "Kiribati", dial: "+686", primary: true },
  { code: "XK", name: "Kosovo", dial: "+383", primary: true },
  { code: "KW", name: "Kuwait", dial: "+965", primary: true },
  { code: "LA", name: "Laos", dial: "+856", primary: true },
  { code: "LS", name: "Lesoto", dial: "+266", primary: true },
  { code: "LV", name: "Letonia", dial: "+371", primary: true },
  { code: "LB", name: "Líbano", dial: "+961", primary: true },
  { code: "LR", name: "Liberia", dial: "+231", primary: true },
  { code: "LY", name: "Libia", dial: "+218", primary: true },
  { code: "LI", name: "Liechtenstein", dial: "+423", primary: true },
  { code: "LT", name: "Lituania", dial: "+370", primary: true },
  { code: "LU", name: "Luxemburgo", dial: "+352", primary: true },
  { code: "MK", name: "Macedonia del Norte", dial: "+389", primary: true },
  { code: "MG", name: "Madagascar", dial: "+261", primary: true },
  { code: "MY", name: "Malasia", dial: "+60", primary: true },
  { code: "MW", name: "Malaui", dial: "+265", primary: true },
  { code: "MV", name: "Maldivas", dial: "+960", primary: true },
  { code: "ML", name: "Mali", dial: "+223", primary: true },
  { code: "MT", name: "Malta", dial: "+356", primary: true },
  { code: "MA", name: "Marruecos", dial: "+212", primary: true },
  { code: "MQ", name: "Martinica", dial: "+596", primary: true },
  { code: "MU", name: "Mauricio", dial: "+230", primary: true },
  { code: "MR", name: "Mauritania", dial: "+222", primary: true },
  { code: "YT", name: "Mayotte", dial: "+262" },
  { code: "MX", name: "México", dial: "+52", primary: true },
  { code: "FM", name: "Micronesia", dial: "+691", primary: true },
  { code: "MD", name: "Moldavia", dial: "+373", primary: true },
  { code: "MC", name: "Mónaco", dial: "+377", primary: true },
  { code: "MN", name: "Mongolia", dial: "+976", primary: true },
  { code: "ME", name: "Montenegro", dial: "+382", primary: true },
  { code: "MS", name: "Montserrat", dial: "+1" },
  { code: "MZ", name: "Mozambique", dial: "+258", primary: true },
  { code: "MM", name: "Myanmar (Birmania)", dial: "+95", primary: true },
  { code: "NA", name: "Namibia", dial: "+264", primary: true },
  { code: "NR", name: "Nauru", dial: "+674", primary: true },
  { code: "NP", name: "Nepal", dial: "+977", primary: true },
  { code: "NI", name: "Nicaragua", dial: "+505", primary: true },
  { code: "NE", name: "Níger", dial: "+227", primary: true },
  { code: "NG", name: "Nigeria", dial: "+234", primary: true },
  { code: "NU", name: "Niue", dial: "+683", primary: true },
  { code: "NO", name: "Noruega", dial: "+47", primary: true },
  { code: "NC", name: "Nueva Caledonia", dial: "+687", primary: true },
  { code: "NZ", name: "Nueva Zelanda", dial: "+64", primary: true },
  { code: "OM", name: "Omán", dial: "+968", primary: true },
  { code: "NL", name: "Países Bajos", dial: "+31", primary: true },
  { code: "PK", name: "Pakistán", dial: "+92", primary: true },
  { code: "PW", name: "Palaos", dial: "+680", primary: true },
  { code: "PA", name: "Panamá", dial: "+507", primary: true },
  { code: "PG", name: "Papúa Nueva Guinea", dial: "+675", primary: true },
  { code: "PY", name: "Paraguay", dial: "+595", primary: true },
  { code: "PE", name: "Perú", dial: "+51", primary: true },
  { code: "PF", name: "Polinesia Francesa", dial: "+689", primary: true },
  { code: "PL", name: "Polonia", dial: "+48", primary: true },
  { code: "PT", name: "Portugal", dial: "+351", primary: true },
  { code: "PR", name: "Puerto Rico", dial: "+1" },
  { code: "HK", name: "RAE de Hong Kong (China)", dial: "+852", primary: true },
  { code: "MO", name: "RAE de Macao (China)", dial: "+853", primary: true },
  { code: "GB", name: "Reino Unido", dial: "+44", primary: true },
  { code: "CF", name: "República Centroafricana", dial: "+236", primary: true },
  { code: "CD", name: "República Democrática del Congo", dial: "+243", primary: true },
  { code: "DO", name: "República Dominicana", dial: "+1" },
  { code: "RE", name: "Reunión", dial: "+262", primary: true },
  { code: "RW", name: "Ruanda", dial: "+250", primary: true },
  { code: "RO", name: "Rumanía", dial: "+40", primary: true },
  { code: "RU", name: "Rusia", dial: "+7", primary: true },
  { code: "EH", name: "Sáhara Occidental", dial: "+212" },
  { code: "WS", name: "Samoa", dial: "+685", primary: true },
  { code: "AS", name: "Samoa Americana", dial: "+1" },
  { code: "BL", name: "San Bartolomé", dial: "+590" },
  { code: "KN", name: "San Cristóbal y Nieves", dial: "+1" },
  { code: "SM", name: "San Marino", dial: "+378", primary: true },
  { code: "MF", name: "San Martín", dial: "+590" },
  { code: "PM", name: "San Pedro y Miquelón", dial: "+508", primary: true },
  { code: "VC", name: "San Vicente y las Granadinas", dial: "+1" },
  { code: "SH", name: "Santa Elena", dial: "+290", primary: true },
  { code: "LC", name: "Santa Lucía", dial: "+1" },
  { code: "ST", name: "Santo Tomé y Príncipe", dial: "+239", primary: true },
  { code: "SN", name: "Senegal", dial: "+221", primary: true },
  { code: "RS", name: "Serbia", dial: "+381", primary: true },
  { code: "SC", name: "Seychelles", dial: "+248", primary: true },
  { code: "SL", name: "Sierra Leona", dial: "+232", primary: true },
  { code: "SG", name: "Singapur", dial: "+65", primary: true },
  { code: "SX", name: "Sint Maarten", dial: "+1" },
  { code: "SY", name: "Siria", dial: "+963", primary: true },
  { code: "SO", name: "Somalia", dial: "+252", primary: true },
  { code: "LK", name: "Sri Lanka", dial: "+94", primary: true },
  { code: "ZA", name: "Sudáfrica", dial: "+27", primary: true },
  { code: "SD", name: "Sudán", dial: "+249", primary: true },
  { code: "SS", name: "Sudán del Sur", dial: "+211", primary: true },
  { code: "SE", name: "Suecia", dial: "+46", primary: true },
  { code: "CH", name: "Suiza", dial: "+41", primary: true },
  { code: "SR", name: "Surinam", dial: "+597", primary: true },
  { code: "SJ", name: "Svalbard y Jan Mayen", dial: "+47" },
  { code: "TH", name: "Tailandia", dial: "+66", primary: true },
  { code: "TW", name: "Taiwán", dial: "+886", primary: true },
  { code: "TZ", name: "Tanzania", dial: "+255", primary: true },
  { code: "TJ", name: "Tayikistán", dial: "+992", primary: true },
  { code: "IO", name: "Territorio Británico del Océano Índico", dial: "+246", primary: true },
  { code: "PS", name: "Territorios Palestinos", dial: "+970", primary: true },
  { code: "TL", name: "Timor-Leste", dial: "+670", primary: true },
  { code: "TG", name: "Togo", dial: "+228", primary: true },
  { code: "TK", name: "Tokelau", dial: "+690", primary: true },
  { code: "TO", name: "Tonga", dial: "+676", primary: true },
  { code: "TT", name: "Trinidad y Tobago", dial: "+1" },
  { code: "TA", name: "Tristán de Acuña", dial: "+290" },
  { code: "TN", name: "Túnez", dial: "+216", primary: true },
  { code: "TM", name: "Turkmenistán", dial: "+993", primary: true },
  { code: "TR", name: "Turquía", dial: "+90", primary: true },
  { code: "TV", name: "Tuvalu", dial: "+688", primary: true },
  { code: "UA", name: "Ucrania", dial: "+380", primary: true },
  { code: "UG", name: "Uganda", dial: "+256", primary: true },
  { code: "UY", name: "Uruguay", dial: "+598", primary: true },
  { code: "UZ", name: "Uzbekistán", dial: "+998", primary: true },
  { code: "VU", name: "Vanuatu", dial: "+678", primary: true },
  { code: "VE", name: "Venezuela", dial: "+58", primary: true },
  { code: "VN", name: "Vietnam", dial: "+84", primary: true },
  { code: "WF", name: "Wallis y Futuna", dial: "+681", primary: true },
  { code: "YE", name: "Yemen", dial: "+967", primary: true },
  { code: "DJ", name: "Yibuti", dial: "+253", primary: true },
  { code: "ZM", name: "Zambia", dial: "+260", primary: true },
  { code: "ZW", name: "Zimbabue", dial: "+263", primary: true },
];

const BY_CODE = new Map(PHONE_COUNTRIES.map((c) => [c.code, c]));

export const countryByCode = (code) => BY_CODE.get(String(code || "").toUpperCase()) || null;

// El indicativo de un país, con Colombia como red de seguridad: un código que no
// esté en la lista no puede dejar el formulario sin poder componer un número.
export const dialFor = (code) =>
  (countryByCode(code) || countryByCode(DEFAULT_PHONE_COUNTRY)).dial;

// La bandera se DERIVA del código ISO (dos indicadores regionales), en vez de
// guardar 245 emojis: son los mismos dos caracteres siempre.
export const flagFor = (code) => {
  const c = String(code || "").toUpperCase();
  if (!/^[A-Z]{2}$/.test(c)) return "";
  return String.fromCodePoint(...[...c].map((ch) => 0x1f1e6 + ch.charCodeAt(0) - 65));
};

// El país cuyo NOMBRE coincide con el texto dado, para enlazar el teléfono con
// el campo `country` de la entidad (texto libre: "Colombia", "colombia", "Perú").
// Devuelve null si no encaja ninguno, y entonces manda el país por defecto.
export const countryCodeForName = (name) => {
  const q = String(name || "").trim().toLowerCase();
  if (!q) return null;
  const hit = PHONE_COUNTRIES.find((c) => c.name.toLowerCase() === q);
  return hit ? hit.code : null;
};

// El país de un número ya en E.164, por el indicativo MÁS LARGO que le encaje
// (+1 antes que +1268 daría el país equivocado). Ante un indicativo compartido
// gana el país principal.
export const countryFromE164 = (e164) => {
  const s = String(e164 || "").trim();
  if (!s.startsWith("+")) return null;
  let best = null;
  for (const c of PHONE_COUNTRIES) {
    if (!s.startsWith(c.dial)) continue;
    if (!best || c.dial.length > best.dial.length) best = c;
    else if (c.dial.length === best.dial.length && c.primary && !best.primary) best = c;
  }
  return best ? best.code : null;
};

// Parte un E.164 en país + número nacional, para volver a llenar el formulario
// con lo que se guardó. Un número que no empieza por + se devuelve tal cual: es
// un fijo escrito a mano, que no se normaliza (ver normalizePhoneNumber).
export const splitE164 = (value, fallbackCountry = DEFAULT_PHONE_COUNTRY) => {
  const s = String(value || "").trim();
  if (!s.startsWith("+")) return { countryCode: fallbackCountry, national: s };
  const code = countryFromE164(s);
  if (!code) return { countryCode: fallbackCountry, national: s.slice(1) };
  return { countryCode: code, national: s.slice(dialFor(code).length) };
};

// Arma el E.164 a partir del país escogido y lo que se tecleó. Los ceros a la
// izquierda del número nacional se caen: se marcan al llamar dentro del país,
// pero no van en E.164.
export const composeE164 = (countryCode, national) => {
  const digits = String(national || "").replace(/\D/g, "").replace(/^0+/, "");
  if (!digits) return "";
  return `${dialFor(countryCode)}${digits}`;
};

// Regenerar (libphonenumber-js es transitiva; si desaparece, instalarla suelta):
//   node -e 'const {getCountries,getCountryCallingCode}=require("libphonenumber-js"); ...'
// El script completo está en el commit que creó este archivo.
